import { createThemeCompiler } from '../../../utils';

export const notificationMessageThemeCompiler = createThemeCompiler(({ palette, borderRadius, stroke }) => ({
    notificationMessage: {
        colors: {
            error: {
                backgroundColor: '#F8F0F2',
                textColor: palette.red,
                borderColor: palette.red
            },
            information: {
                backgroundColor: palette.themeLighterAlt,
                textColor: palette.neutralPrimary,
                borderColor: palette.themePrimary
            },
            success: {
                backgroundColor: '#EDF5F2',
                textColor: palette.green,
                borderColor: palette.green
            },
            warning: {
                backgroundColor: '#FDF8F1',
                textColor: '#34495E',
                borderColor: '#FFA200'
            }
        },
        composites: {
            borderWidth: stroke.thin,
            borderRadius: borderRadius.curvedSmall
        }
    }
}));
